import { combineReducers } from "redux";
import settings from "./settings";

const rootReducer = combineReducers({
  settings,
});

export default rootReducer;
